module.exports = __webpack_public_path__ + "img/logo_little.c4920678.png";